import './layout.css';
import React from 'react';

function InputControlRow({
  bold = false,
  nolabel = false,
  nocontrol = false,
  label=undefined,
  width=undefined,
  children=undefined,
  onLabelClick= undefined,
  underline = false,
  customFontSize = undefined,
}: {
  bold?: boolean,
  nolabel?: boolean,
  nocontrol?: boolean,
  underline?: boolean,
  width?: string|undefined,
  onLabelClick?: VoidFunction|undefined,
  children?: React.ReactChild|React.ReactNode|string|null|undefined,
  label?: React.ReactNode|string|undefined,
  customFontSize?: string|undefined,
}) {
  const inputStyle:React.CSSProperties|undefined = !!width
    ? { width }
    : undefined;

  let labelStyle: React.CSSProperties = !!bold ? { fontWeight: 'bold' } : {};
  if (!!customFontSize) labelStyle = { ...labelStyle, fontSize: customFontSize }
  if (!!onLabelClick) {
    labelStyle = {...labelStyle, cursor: 'pointer'}
  } else {
    labelStyle = {...labelStyle, cursor: 'default'};
  }

  return (
    <div className="ifms-input-ctr-row2" style={inputStyle}>
      {!nolabel &&
        <div className="ifms-input-ctr-row2-label" style={labelStyle} onClick={onLabelClick}>
          {!!underline &&
            <u>{label}</u>
          }
          {!underline &&
            <>{label}</>
          }
        </div>
      }
      {!nocontrol &&
        <div className="ifms-input-ctr-row2-control">
          {children}
        </div>
      }
    </div>
  );
}

export default React.memo(InputControlRow);
